export function downloadFileByLink(fileUrl: string, filename = '', target?: string) {
	const linkElement = document.createElement('a')
	linkElement.download = filename
	linkElement.style.display = 'none'
	linkElement.href = fileUrl
	if (target) {
		linkElement.target = target
	}

	const linkParent = document.body
	linkElement.addEventListener('click', () => {
		linkParent.removeChild(linkElement)
	})
	linkParent.appendChild(linkElement)

	linkElement.click()
}
